import script from "./RightSideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./RightSideBar.vue?vue&type=script&lang=ts&setup=true"

import "./RightSideBar.vue?vue&type=style&index=0&id=78f305b7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f305b7"]])

export default __exports__